/* global window console document */

import $ from "jquery";
import { highContrastCheck, highContrastToggle } from "../high-contrast.js";
import { navigationPanelOpen, isNavigationPanelOpen, isDialogOpen } from "../navigation-panel/navigation-panel.js";

/**
* A string containing a selector that includes the entire tooltip and its
* related elemernts (wrapper, contents of wrapper and button).
* @const
*/
const selectorAccessibilityTooltipContents = [
  ".c-header-accessibility-tooltip *",
  ".c-header__accessibility-tooltip-button",
  ".c-header-accessibility-tooltip"
].join(", ");

// Declare pre-stored DOM elements.
//
// While the elements aren't available until the DOM is ready (so they can't be
// selected here), they must be declared here in order to bring them into the
// global namespace of this file, as otherwise they would not be available to
// the rest of the functions which rely on them.

let elHighContrastToggleButton;
let elAccessibilityTooltipToggle;
let elAccessibilityTooltipWrapper;
let elHamburgerToggleButton;
let elNavigationMenuPointer;
let elCompactHeader;
let elCompactHeaderTopButton;
let elPageName;

const modifierAccessibilityTooltipOpen = "c-header-accessibility-tooltip--open";
const modifierNagivationMenuPointerHidden = "c-header__navigation-menu-pointer--hidden";

let headerHeight;

//onload
$(() => {
  // Pre-store selectors as DOM elements
  //
  // They were declared before without value, and now a value must be assigned
  // to each of them.
  elHighContrastToggleButton = $(".c-header-accessibility-tooltip__hc-toggle");
  elAccessibilityTooltipToggle = $(".c-header__accessibility-tooltip-button");
  elAccessibilityTooltipWrapper = $(".c-header-accessibility-tooltip");
  elHamburgerToggleButton = $(".c-header__hamburger");
  elPageName = $(".c-header-compact__page-name");
  elNavigationMenuPointer = $(".c-header__navigation-menu-pointer");
  elCompactHeader = $(".c-header-compact");
  elCompactHeaderTopButton = $(".c-header-compact__top-button");
  setupDesktopNavPointer();
  setupHamburger();

  // Check if high contrast mode needs to be toggled on
  highContrastCheck();

  // Bind the high contrast tooltip
  elHighContrastToggleButton.on("click", highContrastToggle);

  bindAccessibilityTooltip();
  setupCompactHeader();
});

/**
 * Bind the accessibility tooltip to the DOM
 *
 * @returns {undefined}
 */
function bindAccessibilityTooltip() {
  elAccessibilityTooltipToggle.on("click keypress", (event) => {
    const accessibilityIsOpen = elAccessibilityTooltipWrapper.hasClass(modifierAccessibilityTooltipOpen);

    if (accessibilityIsOpen) {
      closeAccessibilityTooltip();
    } else {
      openAccessibilityTooltip();
    }

    // Finally, prevent the default action.
    event.preventDefault();
  });
}

/**
 * Open the accessibility tooltip. This also binds all required attributes,
 * adds the required class and such.
 *
 * @returns {undefined}
 */
function openAccessibilityTooltip() {
  // Set the tooltip wrapper to have the open class
  elAccessibilityTooltipWrapper.addClass(modifierAccessibilityTooltipOpen)
    // Set the wrapper's hidden to false
    .attr("aria-hidden", "false")
    // Set the buttons' tabindex to 0 to make them tabbable
    .find("[role=switch], a").attr("tabindex", 0);

  // Set the panel to be aria-expanded
  elAccessibilityTooltipToggle
    .attr("aria-expanded", "true");


  // Bind event to the rest of the DOM.

  // The event is namespaced (.accessibility). The reason for this is that it
  // will be possible to later remove this event handler when it's run its
  // course (i.e. when the a11y tooltip closes).
  $(document).on("click.accessibility keypress.accessibility", (event) => {
    if (event.target.matches(selectorAccessibilityTooltipContents)) {
      console.log("Not closing because of selector match.");
    } else {
      console.log("Closing a11y tooltip because of selector match.");
      closeAccessibilityTooltip();
    }
  });
}

/**
 * Close the accessibility tooltip. This also binds all required attributes,
 * removes the required class and such.
 *
 * @returns {undefined}
 */
function closeAccessibilityTooltip() {
  // Remove the tooltip's open class
  elAccessibilityTooltipWrapper.removeClass(modifierAccessibilityTooltipOpen)
    // Set the tooltip to be aria-hidden
    .attr("aria-hidden", "true")
    // Set the buttons to be untabbable again
    .find("[role=switch], a").attr("tabindex", -1);

  // Set button to be collapsed
  elAccessibilityTooltipToggle
    .attr("aria-expanded", "false");

  $(document).off("click.accessibility keypress.accessibility");
}

//sets the hamburger to open the side nav panel
function setupHamburger() {
  // Open the navigation panel when the hamburger is clicked.
  elHamburgerToggleButton.on("click", ()=> {
    openNavpanel();
  });

  elPageName.on("click", ()=> {
    openNavpanel();
  });
}

//sets up the arrow in the header navigation panel on desktop
function setupDesktopNavPointer() {
  $(".c-header__navigation-menu-list li").each(function (index) {
    $(this).attr("index", index);

    $(this).mouseenter(function () {
      resetPointer();
      elNavigationMenuPointer.addClass("c-header__navigation-menu-pointer--pos-" + $(this).attr("index"));
    });

    $(this).mouseleave(function () {
      resetPointer();
      pointerToCurrentPage();
    });
  });

  elNavigationMenuPointer.one("transitionend", function(){
    elNavigationMenuPointer.removeClass(modifierNagivationMenuPointerHidden);
   });
  pointerToCurrentPage();
}

function pointerToCurrentPage() {
  elNavigationMenuPointer.addClass("c-header__navigation-menu-pointer--pos-" + $("li[aria-current='page'][index]").attr("index"));
}

//resets the pointer in the navigation menu in the header
function resetPointer() {
  for(var i=0; i<5; i++){
    elNavigationMenuPointer.removeClass("c-header__navigation-menu-pointer--pos-" + i);
  }
}

//close the compact header
function compactHeaderClose() {
  elCompactHeader.removeClass("c-header-compact--open");
  elCompactHeader.attr("aria-hidden", true);
  elCompactHeader.find("*").attr("tabindex", "-1");
}

//open the compact header
function compactHeaderOpen() {
  elCompactHeader.addClass("c-header-compact--open")
  .attr("aria-hidden", false)
  .find("button").attr("tabindex", "0"); //make the hamburger and go-to-top button tabbable
}

// Check if the compact header needs to be opened or closed
export function compactHeaderCheck() {
  if(($(document).scrollTop() > headerHeight) && !isNavigationPanelOpen() && !isDialogOpen()) {
    compactHeaderOpen();
  }
  else {
    compactHeaderClose();
  }
}

function setupCompactHeader() {
  headerHeight = $(".c-header").height();

  $(window).scroll(compactHeaderCheck);

  elCompactHeaderTopButton.click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });

  compactHeaderCheck();
}

function openNavpanel() {
  navigationPanelOpen();
  compactHeaderClose();
}




// WEBPACK FOOTER //
// ./src/frontend/common/page/header/header.js